import { useAccount } from '@app/src/context/AccountContext'
import { Box } from '@mui/material'
import React from 'react'
import NavBreadcrumbs from '../Breadcrumbs/NavBreadcrumbs'

/**
 * Legacy-only wrapper that surfaces the new breadcrumbs below the legacy navbar.
 * In vertical-nav mode the breadcrumbs live in the HorizontalMenu, which is not
 * rendered in legacy mode — so we render them here instead. Deletes with the folder.
 */
const LegacyBreadcrumbs = (): JSX.Element | null => {
  const { account } = useAccount()

  if (!account?.organization) return null

  return (
    <Box
      sx={{
        mt: 3,
        pl: 1,
      }}
    >
      <NavBreadcrumbs />
    </Box>
  )
}

export default LegacyBreadcrumbs
